import { PageTheme } from "@/hooks/usePageTheme";

/** Page background color class per theme — shared by the layout and the sticky header. */
export const BACKGROUND_BY_THEME: Record<PageTheme, string> = {
	dark: "bg-secondary-500",
	light: "bg-neutral-0",
};

/** Header bottom-border color class per theme. */
export const BORDER_BY_THEME: Record<PageTheme, string> = {
	dark: "border-secondary-300",
	light: "border-neutral-100",
};
